import { URL_API } from "@/config";
import { tokenDecrypted } from "@/utils/decryptToken";
import { url } from "@/utils/urlParam";
import axios from "axios";

export async function getPayrunTypes(companyId) {
  try {
    const params = new URLSearchParams(url.search);
    if (companyId) {
      params.append("company_id", companyId);
    }
    const { data } = await axios.get(
      `${URL_API}/payrun-type?${params.toString()}`,
      {
        headers: {
          Authorization: `Bearer ${tokenDecrypted()}`,
        },
      }
    );
    return { success: true, message: "", data: data.data };
  } catch (error) {
    return {
      success: false,
      code: error.response.status,
      message: error.response.statusText,
      data: [],
    };
  }
}

export async function addPayrunType(payload) {
  try {
    const { company, description, name, selectedFile, color } = payload;
    const payloadPayrunType = {
      company_id: company,
      payrun_type: name,
      description,
      color,
      output_file: selectedFile,
    };
    const { data } = await axios.post(
      `${URL_API}/payrun-type`,
      payloadPayrunType,
      {
        headers: {
          Authorization: `Bearer ${tokenDecrypted()}`,
        },
      }
    );
    return {
      success: true,
      code: 200,
      message: "",
      data: data,
    };
  } catch (error) {
    return {
      success: false,
      code: error.response.status,
      message: error.response.statusText,
      data: error.response.data || null,
    };
  }
}

export async function updatePayrunType(payload) {
  try {
    const { company, description, name, selectedFile, color, id } = payload;

    const payloadPayrunType = {
      company_id: company,
      payrun_type: name,
      description,
      color,
      output_file: selectedFile,
    };
    const { data } = await axios.put(
      `${URL_API}/payrun-type/${id}`,
      payloadPayrunType,
      {
        headers: {
          Authorization: `Bearer ${tokenDecrypted()}`,
        },
      }
    );
    return {
      success: true,
      code: 200,
      message: "",
      data: data,
    };
  } catch (error) {
    return {
      success: false,
      code: error.response.status,
      message: error.response.statusText,
      data: error.response.data || null,
    };
  }
}

export async function deletePayrunType(id) {
  try {
    const { data } = await axios.delete(`${URL_API}/payrun-type/${id}`, {
      headers: {
        Authorization: `Bearer ${tokenDecrypted()}`,
      },
    });

    return {
      success: true,
      code: 200,
      message: "",
      data: data,
    };
  } catch (error) {
    return {
      success: false,
      code: error.response.status,
      message: error.response.statusText,
      data: error.response.data || null,
    };
  }
}

export async function savePayrunTypeEmployee({ id, payrunType }) {
  try {
    const { data } = await axios.put(
      `${URL_API}/employment/${id}/payrun-type`,
      { payrun_type: `${payrunType}` },
      {
        headers: {
          Authorization: `Bearer ${tokenDecrypted()}`,
        },
      }
    );
    return {
      success: true,
      message: "",
      data: data,
    };
  } catch (error) {
    return {
      success: false,
      code: error.response.status,
      message: error.response.statusText,
      data: [],
    };
  }
}

export async function updateDefaultPayrunType({ id, isDefault }) {
  try {
    await axios.put(
      `${URL_API}/payrun-type/default/${id}`,
      {
        is_default: isDefault,
      },
      {
        headers: {
          Authorization: `Bearer ${tokenDecrypted()}`,
        },
      }
    );

    return {
      success: true,
      message: "",
      code: 200,
      data: null,
    };
  } catch (error) {
    return {
      success: false,
      code: error.response.status,
      message: error.response.statusText,
      data: [],
    };
  }
}
